import { BalanceSheetVoucherRowsData } from "@/types/balance-sheet-voucher-rows-api";
import { api, withErrorHandling } from "./api";

export const getBalanceSheetVoucherRows = async (
    clientId: string,
    connectionIds: string[],
    months: number[],
    year: number

): Promise<BalanceSheetVoucherRowsData> => {
    const response = await withErrorHandling(() =>
        api.get<BalanceSheetVoucherRowsData>(`/clients/${clientId}/report/balance-sheet/voucher-rows`, {
            params: {
                clientId: clientId,
                connectionIds: connectionIds[0],
                Year: year,
                Month: months[months.length - 1]
            },
        })
    );
    return response.data;
};
